import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	StarterDashboardShareRecommendationsConfigQuery,
	StarterDashboardShareRecommendationsConfigQueryVariables,
} from './shouldLoadShareRecommendations.graphql';
import { StarterDashboardShareRecommendationsConfig } from './shouldLoadShareRecommendations.graphql';

export async function shouldLoadShareRecommendations(utilityContext: UtilityContext) {
	const {
		data: {
			featureConfigs: { starterExperienceShareRecommendations },
		},
	} = await utilityContext.gql.fetch<
		StarterDashboardShareRecommendationsConfigQuery,
		StarterDashboardShareRecommendationsConfigQueryVariables
	>({
		query: StarterDashboardShareRecommendationsConfig,
		rejectOnError: true,
	});

	return starterExperienceShareRecommendations.isEnabled;
}
